import { useMutation, useQueryClient } from '@tanstack/react-query';
import insurancesApi from '@/features/dashboard/insurances/api/insurancesApi.ts';
import { insurancesApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useDeleteInsurance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => insurancesApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: insurancesApiQueryKeys.all(),
      });
      toast.success('Ubezpieczenie zostało usunięte');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas usuwania ubezpieczenia.',
      });
    },
  });
}
